export const sliceName = 'note';

export const getNotesActionType = `${sliceName}/getNotes`;

export const addNoteActionType = `${sliceName}/addNote`;

export const editNoteActionType = `${sliceName}/editNote`;
